
import { useDispatchStoreAction } from '~/mixins/DispatchStoreAction'

export default {
  mixins: [
    useDispatchStoreAction({
      action: 'newsletter-form/subscribe',
    }),
  ],

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      hasSubmitted: false,

      salutationOptions: [
        { value: 'male', label: 'Herr' },
        { value: 'female', label: 'Frau' },
        { value: 'none', label: 'keine Angabe' },
      ],

      emptyForm: {
        salutation: '',
        firstname: '',
        lastname: '',
        email: '',
      },

      form: {},
    }
  },

  mounted() {
    this.resetFormFields()
  },

  methods: {
    resetFormFields() {
      this.form = { ...this.emptyForm }
      this.$refs.observer.reset()
      this.hasSubmitted = false
    },

    async submitForm() {
      this.hasSubmitted = true

      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      if (this.storeAction.state === 'loading') {
        return
      }

      try {
        await this.dispatchStoreAction(
          {
            audience_id: this.data.mailchimp_audience_id,
            ...this.form,
          },
          {
            silentOnSuccess: true,
            silentOnError: true,
          }
        )

        this.$toast.success(
          'Vielen Dank! Sie haben sich erfolgreich für den Newsletter angemeldet.'
        )
      } catch (error) {
        this.$toast.error(
          'Leider gab es ein Problem. Bitte versuchen Sie es später nochmal.'
        )
      }

      this.resetFormFields()
    },
  },
}
